<template>
    <div class="slm-history-map__result">
        <view-toggle-component/>
        <!-- <div class="slm-history-map__result--item" v-for="municipality in historiesByMunicipality.municipalities" :key="municipality.title">
            <h2 class="slm-history-map__result--item__title">{{municipality.title}}</h2>
        </div> -->
        <list-component :histories="histories"/>
        <load-more v-if="showLoadMore"/>
    </div>
</template>

<script>
import listComponent from './list.vue'
import LoadMore from './load-more.vue';
import viewToggleComponent from './view-toggle.vue'
export default {
    name: 'result-view-component',
    data() {
        return {
            loaded: 0
        }
    },
    computed: {
        page() {
            return this.$store.state.page;
        },
        showLoadMore() {
            const histories = this.$store.state.filteredHistories;
            const page = this.$store.state.page;
            const postsPerPage = this.$store.state.postsPerPage;
            const pages = Math.ceil(histories.length / postsPerPage);
            return page < pages;
        },
        historiesByMunicipality() {
            return this.$store.getters.historiesByMunicipality;
        },
        histories() {
            return this.$store.getters.filteredHistories;
        },
        listView() {
            return this.$store.state.listView;
        }
    },
    components: {
        listComponent,
        viewToggleComponent,
        LoadMore
    }
}
</script>
